import type { FC } from 'react'

import { ImageWithIconFallback } from '@skytech/ui/Image'
import ImageOffOutlineIcon from 'mdi-react/ImageOffOutlineIcon'
import type { WrappedComponentProps } from 'react-intl'
import { injectIntl } from 'react-intl'

import { Translation } from '../i18n/Translation'

import type { Inventory, Order } from './types'

import './style/addons.scss'

const Addons: FC<
  {
    order: Order
    inventory: Record<string, Inventory>
    removeAddon: (productId: number) => void
    addAddon: (productId: number) => void
  } & WrappedComponentProps
> = ({ order, intl, inventory, addAddon, removeAddon }) => {
  const { formatMessage } = intl

  if (!order) return null

  const addons = order.mainProduct.children

  return (
    <>
      {Object.keys(inventory).map(model =>
        inventory[model].map(product => {
          if (!addons?.find(addonId => addonId === product.id)) return null

          const selected = order.products.find(orderProducId => orderProducId === product.id)

          let onClick = selected ? () => removeAddon(product.id) : () => addAddon(product.id)

          if (product.stock === '0') {
            onClick = () => alert(formatMessage({ id: 'Mangler på lager og kan ikke bestilles.' }))
          }

          return (
            <div
              key={product.id}
              role="button"
              className="order-addons-addon"
              tabIndex={0}
              onClick={onClick}
              onKeyDown={onClick}
            >
              <div className="order-addons-addon-header">{product.model}</div>

              <div className="order-addons-addon-image">
                <ImageWithIconFallback
                  src={product.imgUrl}
                  alt={product.model}
                  fallbackIcon={<ImageOffOutlineIcon />}
                />
              </div>

              <div className="order-addons-addon-stock">
                <Translation id="{amount} på lager" values={{ amount: product.stock }} />
              </div>

              <div
                className={
                  'order-addons-addon-selector ' + (selected ? 'selected' : 'not-selected')
                }
              >
                {selected ? <Translation id="valgt" /> : <Translation id="ikke valgt" />}
              </div>
            </div>
          )
        })
      )}
    </>
  )
}

export default injectIntl(Addons)
